// Lib
import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

// Utils
import { getFileType } from '../../../../common/elements/utils/elementPropertyUtils';
import { isPlatformIpad } from '../../../platform/utils/platformDetailsUtils';

// Selectors
import { currentBoardHasMediaDownloadAccessSelector } from '../../../utils/permissions/elementPermissionsSelector';
import { getAttachment } from '../../attachments/attachmentsSelector';
import { getPlatformDetailsSelector } from '../../../platform/platformSelector';

// Components
import FileModalIFrameView from './FileModalIFrameView';
import FileModalDefaultView from './FileModalDefaultView';

// Constants
import { FILE_TYPES_INFO } from '../../../../common/files/fileConstants';

// Types
import { ImMNElement } from '../../../../common/elements/elementModelTypes';

// Styles
import './FileModal.scss';

const mapStateToProps = createStructuredSelector({
    attachment: getAttachment,
    showDownloadOption: currentBoardHasMediaDownloadAccessSelector,
    platformDetails: getPlatformDetailsSelector,
});

const getFileModalView = (fileType: string, platformDetails: any): [React.FC<any>, string] => {
    switch (fileType) {
        case FILE_TYPES_INFO.PDF.type:
            // iOS doesn't have good support for viewing PDFs in iFrames, so just display the default file view
            // TODO: WEB-12978 if we replace the PDF viewer with a custom solution, we can remove this logic and allow the PDF viewer
            return isPlatformIpad(platformDetails)
                ? [FileModalDefaultView, 'default-view']
                : [FileModalIFrameView, 'native-view'];
        case FILE_TYPES_INFO.TEXT.type:
            return [FileModalIFrameView, 'native-view'];
        default:
            return [FileModalDefaultView, 'default-view'];
    }
};

const FileModal: React.FC<{
    element: ImMNElement;
    attachment: any;
    showDownloadOption: boolean;
    platformDetails: any;
}> = (props) => {
    const { element, platformDetails } = props;

    const fileType: string = getFileType(element);

    const [FileModalRenderer, modalClassName] = getFileModalView(fileType, platformDetails);

    return (
        <div className={classNames('FileModal', modalClassName)}>
            <FileModalRenderer {...props} />
        </div>
    );
};

export default connect(mapStateToProps)(FileModal);
